// extracted by mini-css-extract-plugin
module.exports = {"viewport":"styles_viewport__1X0DN","container":"styles_container__rP4h6","slide":"styles_slide__eyHEJ","middle-column":"styles_middle-column__gYq9l"};